<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">CUMPLEAÑEROS</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">CUMPLEAÑOS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>LISTADO DE CUMPLEAÑEROS</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-4">
          <span><strong>CUMPLEAÑEROS MES: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="mes_cumpleanios"
              :options="meses"
              optionLabel="label"
              placeholder="Seleccione un mes"
              :filter="true"
              @change="BuscarFiltro()"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span>&nbsp;</span>
          <div class="p-inputgroup">
            <span style="font-weight: bold; font-size: 1.2rem"><strong>CUMPLEAÑOS HOY</strong></span>
            <Checkbox
              :disabled="enviando"
              v-model="hoy"
              :binary="true"
              v-tooltip.top="'Cumpleaños de hoy'"
              @change="cambiarHoy()"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span>&nbsp;</span>
          <div class="p-inputgroup">
            <span style="font-weight: bold; font-size: 1.2rem"><strong>CUMPLEAÑOS MAÑANA</strong></span>
            <Checkbox
              :disabled="enviando"
              v-model="manana"
              :binary="true"
              v-tooltip.top="'Cumpleaños del mes'"
              @change="cambiarManana()"
            />
          </div>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Buscar'"
            :loading="enviando"
            @click="BuscarFiltro()"
          />
        </div>
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="reporte_cumpleanios"
        key="id"
        :value="cumpleanios"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm tabla-cumpleanios"
        :filters="buscar"
        responsive="true"
        stripedRows
        showGridlines
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar..." />
            </span>
            <Button
              v-if="hoy"
              label="ENVIAR FELICITACIÓN"
              icon="pi pi-whatsapp"
              class="p-button-success"
              v-tooltip.top="'Enviar mensaje de WhatsApp'"
              @click="enviarWhatsapp()"
            />
          </div>
        </template>
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span
            class="flex align-items-center justify-content-center"
            style="background-color: #f8d7da; padding: 5px; border-radius: 5px; color: #721c24"
          >
            Debe aplicar filtros para ver resultados en la tabla!</span
          >
        </template>
        <Column header="#" style="width: 50px">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>
        <Column class="text-right" field="id" header="CÓD" :sortable="true" style="width: 80px"> </Column>

        <Column field="nombre" header="CLIENTE">
          <template #body="{ data }">
            <div>
              <div style="font-weight: 600">
                {{ data.nombre }}
              </div>
              <div v-if="data.nombre_duenio" style="font-size: 0.85rem; color: #666; margin-top: 2px">
                Propietario: {{ data.nombre_duenio }}
              </div>
            </div>
          </template>
        </Column>

        <Column field="fecha_cumple" header="EDAD/AÑOS" style="width: 120px">
          <template #body="{ data }">
            <div style="font-weight: 700">
              <span v-if="data.tipo_cumple === 'cumpleanos_duenio'">
                {{ calcularEdadQueVaACumplir(data.fecha_cumple) }}
              </span>
              <span v-else>
                {{ calcularAniosQueVaACumplir(data.fecha_cumple) }}
              </span>
            </div>
          </template>
        </Column>

        <Column field="fecha_cumple" header="CUMPLEAÑOS" style="min-width: 280px">
          <template #body="{ data }">
            <div style="display: flex; align-items: center; gap: 0.6rem">
              <i
                :class="data.tipo_cumple === 'aniversario_negocio' ? 'pi pi-building' : 'pi pi-gift'"
                :style="{
                  fontSize: '1.1rem',
                  color: data.tipo_cumple === 'aniversario_negocio' ? '#3498db' : '#e74c3c'
                }"
              ></i>

              <span style="color: #555; font-weight: 500">
                {{ data.tipo_cumple === 'aniversario_negocio' ? 'Aniversario del Negocio' : 'Cumpleaños del Dueño' }}
              </span>

              <span style="font-weight: 600">
                {{ formatFecha(data.fecha_cumple) }}
              </span>

              <Badge v-if="hoy || data.esta_de_cumple" value="HOY" severity="warning" />

              <Badge v-else-if="manana || data.cumple_manana" value="MAÑANA" severity="info" />
            </div>
          </template>
        </Column>

        <Column field="telefono" header="TELÉFONO" style="width: 110px">
          <template #body="{ data }">
            <div>
              <span v-if="data.tipo_cumple === 'cumpleanos_duenio' && data.telefono_duenio">
                {{ data.telefono_duenio }}
              </span>
              <span v-else-if="data.tipo_cumple === 'aniversario_negocio' && data.telefono">
                {{ data.telefono }}
              </span>
              <span v-else style="color: #999; font-style: italic"> - </span>
            </div>
          </template>
        </Column>

        <Column field="nombre_municipio" header="PROVINCIA"> </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import ClienteService from '@/service/ClienteService'
import { useAuth } from '@/stores'

export default {
  data() {
    return {
      meses: [
        { label: 'ENERO', value: 1 },
        { label: 'FEBRERO', value: 2 },
        { label: 'MARZO', value: 3 },
        { label: 'ABRIL', value: 4 },
        { label: 'MAYO', value: 5 },
        { label: 'JUNIO', value: 6 },
        { label: 'JULIO', value: 7 },
        { label: 'AGOSTO', value: 8 },
        { label: 'SEPTIEMBRE', value: 9 },
        { label: 'OCTUBRE', value: 10 },
        { label: 'NOVIEMBRE', value: 11 },
        { label: 'DICIEMBRE', value: 12 }
      ],
      mes_cumpleanios: null,
      enviando: false,
      cumpleanios: [],
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        }
      },
      hoy: false,
      manana: false
    }
  },
  clienteService: null,
  auth: null,
  mounted() {
    this.mes_cumpleanios = this.meses[new Date().getMonth()]
  },
  created() {
    this.clienteService = new ClienteService()
    this.auth = useAuth()
  },

  methods: {
    calcularEdadQueVaACumplir(fecha) {
      if (!fecha) return 'N/A'

      let partesFecha = fecha.split('-')
      let anio_nacimiento = parseInt(partesFecha[0])

      let fecha_actual = new Date()
      let anio_actual = fecha_actual.getFullYear()

      let edad_que_cumple = anio_actual - anio_nacimiento

      return edad_que_cumple + ' AÑOS'
    },

    calcularAniosQueVaACumplir(fecha) {
      if (!fecha) return 'N/A'

      let partesFecha = fecha.split('-')
      let anio_inicio = parseInt(partesFecha[0])

      let fecha_actual = new Date()
      let anio_actual = fecha_actual.getFullYear()

      let anios_que_cumple = anio_actual - anio_inicio

      if (anios_que_cumple === 0) {
        return 'PRIMER AÑO'
      } else if (anios_que_cumple === 1) {
        return '1 AÑO'
      } else {
        return anios_que_cumple + ' AÑOS'
      }
    },

    enviarWhatsapp() {
      const clientesAgrupados = this.cumpleanios.reduce((acc, cumple) => {
        const key = cumple.id
        if (!acc[key]) {
          acc[key] = {
            id: cumple.id,
            nombre: cumple.nombre,
            nombre_duenio: cumple.nombre_duenio,
            telefono: cumple.telefono,
            telefono_duenio: cumple.telefono_duenio,
            cumpleanos: []
          }
        }
        acc[key].cumpleanos.push({
          tipo: cumple.tipo_cumple,
          fecha: cumple.fecha_cumple
        })
        return acc
      }, {})

      let datos = {
        cumpleanios: Object.values(clientesAgrupados)
      }

      this.clienteService
        .enviarFelicitationWhatsapp(datos)
        .then((data) => {
          if (data.success == false) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: data.message,
              life: 5000
            })
          } else {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: data.message,
              life: 5000
            })
            if (data.no_enviados.length > 0) {
              this.$toast.add({
                severity: 'warn',
                summary: 'Advertencia',
                detail: 'Los siguientes clientes no tienen número de teléfono: ' + data.no_enviados.join(', '),
                life: 20000
              })
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    formatFecha(fecha) {
      if (!fecha) return ''
      let partesFecha = fecha.split('-')
      let fecha_nacimiento = new Date(Date.UTC(partesFecha[0], partesFecha[1] - 1, partesFecha[2]))
      let dia = fecha_nacimiento.getUTCDate()
      let mes_texto = this.mes_texto(fecha_nacimiento.getUTCMonth())
      return dia + ' de ' + mes_texto
    },

    cambiarHoy() {
      if (this.hoy) {
        this.manana = false
        this.mes_cumpleanios = null
        this.BuscarFiltro()
      }
    },

    cambiarManana() {
      if (this.manana) {
        this.hoy = false
        this.mes_cumpleanios = null
        this.BuscarFiltro()
      }
    },

    mes_texto(mes) {
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]
      return meses[mes]
    },

    BuscarFiltro() {
      this.cumpleanios = []
      this.enviando = true
      this.cargarReporteCumpleanios()
    },

    cargarReporteCumpleanios() {
      let datos = {
        mes: this.mes_cumpleanios ? this.mes_cumpleanios.value : null,
        hoy: this.hoy,
        manana: this.manana
      }
      this.clienteService
        .filtrarCumpleanios(datos)
        .then((data) => {
          if (this.hoy) {
            this.cumpleanios = data.cumpleanios_hoy
          } else if (this.manana) {
            this.cumpleanios = data.cumpleanios_manana
          } else {
            this.cumpleanios = data.cumpleanios
          }
          this.enviando = false
        })
        .catch((error) => {
          this.enviando = false
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}

.tabla-cumpleanios::v-deep {
  .p-datatable-thead > tr > th {
    padding: 0.5rem 0.5rem;
  }

  .p-datatable-tbody > tr > td {
    padding: 0.4rem 0.5rem;
  }
}
</style>
